export const clinicData =  [
    {
        id: 1,
        name:"Haemodialysis",
    },
    {
        id: 2,
        name:"Continuous Renal Replacement Therapy",
    },
    {
        id: 3,
        name:"Drug Overdose Clearance",
    },
    {
        id: 4,
        name:"Ultrasound Guided Renal Biopsy",
    },
    {
        id: 5,
        name:"Ultra sound Scan Guided Prostate Biopsy",
    },
    {
        id: 6,
        name:"Endoscopic Prostate Surgeries",
    },
    {
        id: 7,
        name:"Laser Stone Surgeries",
    },
    {
        id: 8,
        name:"Prostate Cancer Treatment",
    },
    {
        id: 9,
        name:"Pediatric Urology",
    },
    {
        id: 10,
        name:"Male Infertility Treatment",
    },
    {
        id: 11,
        name:"Laparoscopy"
    },
    {
        id: 12,
        name:"Renal Transplantation"
    }
]